<template>
  <button :class="['labelMarker', { labelMarker_open:isActive}, {labelMarker_mirrored:isMirrored}, {labelMarker_loaded: isLoaded}]" :id="id"
          :style="{ left: x +'%', top: y + '%'}"
          @click="toggleActive"
          @focus="goActive"
          @blur="goInactive"
    >
    <div class="labelMarker__shrink-wrap" :style="{maxWidth:isActive ? maxWidth+'px' : 0 }">
      <div class="labelMarker__text-wrap">
        <span class="labelMarker__text">{{title}}</span>
      </div>
    </div>
    <div class="labelMarker__pin" :style="{  backgroundColor: color }" >
      <div class="labelMarker__pin-icon-close"></div>
    </div>
  </button>

</template>

<script>

export default {
  name: 'LabelMarker',
  components : {
  },
  data () {
    return {
      isActive:true,
      lastTriggered: Date.now(),
      isLoaded:false,
      pinDiamMin:  24,
      pinDiamMax : 34,
      isMirrored : false,
      maxWidth:'none',
        width:'auto'
    }
  },
  methods : {
    toggleActive (){
        console.log(this.$el);
       this.$el.focus();
      const newTrigger = Date.now();
      if (newTrigger - this.lastTriggered > 200){
        this.lastTriggered = newTrigger;
        this.isActive = !this.isActive;
      }
    },
    goActive (){

      const newTrigger = Date.now();
      if (newTrigger - this.lastTriggered > 200){
        this.lastTriggered = newTrigger;
        this.isActive = true;
      }
    },
    goInactive(){
        console.log('blur');
      const newTrigger = Date.now();
      if (newTrigger - this.lastTriggered > 200){
        this.lastTriggered = newTrigger;
        this.isActive = false;

      }
    },
  },
  props:['x','y','title', 'id', 'color'],
  mounted(){
      //need to figure out some maths for animation
      const pWidth = this.$el.parentElement.clientWidth;
      const pOffset = this.$el.parentElement.getBoundingClientRect().left;
      const rect = this.$el.querySelector('.labelMarker__shrink-wrap').getBoundingClientRect();
    //  console.log(this.$el);
    //  console.log(rect.left);
    //  console.log(rect.x);
      if(((rect.left - pOffset )+ rect.width) >= pWidth ){
          //flip around if too close to edge
          this.isMirrored = true;
      }
      this.width = rect.width;
      this.maxWidth = rect.width;
      this.isActive = false;
      this.isLoaded = true;

  }
}


</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/LabelMarker.vue